import React from "react";
import { AlertTriangle } from "lucide-react";

import { formatarMinutos, gargalo } from "../regras";

// Mesma cor (a da loja), mais forte a cada etapa: a ordem do pedido se lê da esquerda para a direita.
const FORCA = [0.3, 0.5, 0.72, 0.95];

/**
 * A viagem do pedido em uma barra: cada pedaço é o tempo médio de uma etapa,
 * do tamanho do tempo. Embaixo, a legenda com o nome e os minutos; a etapa mais
 * demorada ganha o selo "mais demorada". `compacta`: só a barra (Resumo).
 */
export default function LinhaDoTempo({ etapas, compacta = false }) {
  const comTempo = (etapas || []).filter((e) => e.tempo_medio != null && e.tempo_medio > 0);
  const soma = comTempo.reduce((s, e) => s + e.tempo_medio, 0);
  if (!soma) return compacta ? null : <p className="text-sm text-muted-foreground">Sem tempos registrados no período.</p>;
  const lento = gargalo(etapas);
  return (
    <div data-e2e="linha-do-tempo">
      <div className={`flex w-full gap-[2px] ${compacta ? "h-2.5" : "h-9 sm:h-10"}`}>
        {(etapas || []).map((e, i) => (e.tempo_medio > 0 ? (
          <div key={e.key} title={`${e.rotulo}: ${formatarMinutos(e.tempo_medio)}`}
            className="h-full first:rounded-l-md last:rounded-r-md flex items-center justify-center overflow-hidden"
            style={{ flexGrow: e.tempo_medio, flexBasis: 0, backgroundColor: `hsl(var(--primary) / ${FORCA[i] ?? 1})` }}>
            {!compacta && e.tempo_medio / soma >= 0.14 && (
              <span className={`text-[11px] font-bold whitespace-nowrap px-1 ${(FORCA[i] ?? 1) >= 0.6 ? "text-primary-foreground" : "text-foreground"}`}>{formatarMinutos(e.tempo_medio)}</span>
            )}
          </div>
        ) : null))}
      </div>
      {!compacta && (
        <div className={`grid gap-2 mt-3 ${etapas.length > 3 ? "grid-cols-2 sm:grid-cols-4" : "grid-cols-3"}`}>
          {etapas.map((e, i) => (
            <div key={e.key} className="min-w-0">
              <div className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ backgroundColor: `hsl(var(--primary) / ${FORCA[i] ?? 1})` }} />
                <span className="text-xs text-muted-foreground truncate">{i + 1}. {e.rotulo}</span>
              </div>
              <p className="text-lg font-bold tabular-nums leading-tight pl-4">{formatarMinutos(e.tempo_medio)}</p>
              {lento?.key === e.key && (
                <span className="ml-4 inline-flex items-center gap-1 text-[10px] font-bold uppercase text-amber-700 dark:text-amber-400">
                  <AlertTriangle className="w-3 h-3" /> mais demorada
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
